export const eventBus = new EventTarget();
